import React, { Fragment, useContext } from "react";
import FilterByImage from "./FilterByImage";
import FilterByConfidence from "./FilterByConfidence";
import { Filters } from "../types";
import { SelfieSearchContext } from "../SelfieSearchContext";

const FiltersContainer = ({
  filterSelections,
  updateFilters,
  resetFilter,
  updateImageFilter
}: {
  filterSelections: Filters;
  updateFilters: (filters: Filters) => void;
  resetFilter: () => void;
  updateImageFilter: (imageUrl: string, clearSelfie: boolean) => void;
}) => {
  const context = useContext(SelfieSearchContext);
  const updateFilterBy =
    (filterType: string) => (newValue: string | boolean) => {
      const updatedFilters = {
        ...filterSelections,
        [filterType]: newValue
      };
      updateFilters(updatedFilters);
    };

  return (
    <Fragment>
      <FilterByImage
        selectedImage={filterSelections.referenceImage}
        updateImageFilter={updateImageFilter}
      />
      <FilterByConfidence
        updateFilter={updateFilterBy("confidenceLevel")}
        confidenceLevel={filterSelections.confidenceLevel}
      />
    </Fragment>
  );
};

export default FiltersContainer;
